import { DateRangeSchema, sortOrderType } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';

const ExpenditureBudgetOrganizationBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.number().int().min(1),
  name: z.string(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  sortOrder: sortOrderType.max(9999),
});

export const ExpenditureBudgetOrganizationsModel =
  ExpenditureBudgetOrganizationBaseModel.array();
export const ExpenditureBudgetOrganizationModel =
  ExpenditureBudgetOrganizationBaseModel;

export const ExpenditureBudgetOrganizationFormSchema =
  ExpenditureBudgetOrganizationBaseModel.pick({
    code: true,
    sortOrder: true,
  }).extend({
    name: ExpenditureBudgetOrganizationBaseModel.shape.name.max(
      NAME_MAX_LENGTH,
    ),
    period: DateRangeSchema.nullish(),
  });
